// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/user-api-key-settings-schema',
  type: 'object',
  required: ['apiKeyLength'],
  properties: {
    apiKeyLength: {
      type: 'integer',
    },
    apiKeyPrefix: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
